<template>
  <div class="cost-list-container">
    <el-card class="page-header-card" shadow="hover">
      <div class="page-header">
        <div class="page-title-section">
          <h2 class="page-title">
            <font-awesome-icon icon="dollar-sign" class="page-title-icon" />
            {{ pageTitle }}
          </h2>
          <p class="page-subtitle">{{ pageSubtitle }}</p>
        </div>
        <el-button
          v-if="checkPermissionsPage('admin') && !isDeliveriesRoute"
          @click="createCostDialogOpen()"
          type="primary"
          size="large"
          class="create-button"
        >
          <font-awesome-icon icon="plus" class="button-icon" />
          Шинэ зардал үүсгэх
        </el-button>
      </div>
    </el-card>

    <el-card class="table-card mt-10" shadow="hover">
      <template #header>
        <div class="table-header">
          <font-awesome-icon icon="list" class="table-header-icon" />
          <span class="table-header-title">Зардлын жагсаалт</span>
          <el-tag type="info" class="table-count-tag">{{ data.length }} зардал</el-tag>
        </div>
      </template>
      <el-table :data="data" :key="tableKey" style="width: 100%" border class="modern-cost-table" stripe>
            <!-- Хүргэлт route дээрх columns -->
            <template v-if="isDeliveriesRoute">
              <el-table-column label="Delivery ID" prop="delivery_id" width="120"></el-table-column>
              <el-table-column label="Огноо" prop="date" width="120">
                <template #default="scope">
                  {{ formatDate(scope.row.date) }}
                </template>
              </el-table-column>
              <el-table-column label="Тоо" prop="count" width="100" align="center"></el-table-column>
              <el-table-column label="Утасны дугаар" prop="phone" width="150"></el-table-column>
              <el-table-column label="Хүргэлтийн үнэ" prop="delivery_price" align="right" width="150">
                <template #default="scope">
                  <span class="amount-text">{{ formatAmount(scope.row.delivery_price) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Жолоочид өгөх үнэ" prop="driver_price" align="right" width="180">
                <template #default="scope">
                  <el-input-number
                    v-model="scope.row.driver_price"
                    :min="0"
                    :precision="0"
                    size="small"
                    @change="updateDriverPrice(scope.row)"
                    style="width: 100%"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="Төлөв" prop="status" width="150"></el-table-column>
            </template>
            <!-- Бусад route дээрх columns -->
            <template v-else>
            <!-- Static Columns -->
            <el-table-column label="Огноо" prop="date" width="120">
              <template #default="scope">
                {{ formatDate(scope.row.date) }}
              </template>
            </el-table-column>
            <el-table-column v-if="isRentType" label="Түрээсийн эхлэх огноо" prop="rent_start_date" width="160">
              <template #default="scope">
                {{ formatDate(scope.row.rent_start_date) }}
              </template>
            </el-table-column>
            <el-table-column v-if="isRentType" label="Түрээсийн дуусах огноо" prop="rent_end_date" width="160">
              <template #default="scope">
                {{ formatDate(scope.row.rent_end_date) }}
              </template>
            </el-table-column>
            <el-table-column v-if="isDeliveryType && !isTransferType" label="Хүргэлт хийсэн хэрэглэгч ID" prop="delivery_user_id" width="180"></el-table-column>
            <el-table-column v-if="isSalaryType && !isTransferType" label="Ажилчин ID" prop="employee_id" width="150"></el-table-column>
            <el-table-column v-if="!isSalaryType && !isFlowCostType && !isTransferType" label="Тайлбар" prop="description"></el-table-column>
            <el-table-column v-if="isFlowCostType || isTransferType" label="Тайлбар" prop="description"></el-table-column>
            <el-table-column label="Дүн" prop="amount" align="right" width="120">
              <template #default="scope">
                <span class="amount-text">{{ formatAmount(scope.row.amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Дансны дугаар" prop="account_number" width="150"></el-table-column>
            <el-table-column label="Үүсгэсэн хэрэглэгч ID" prop="created_by_user_id" width="180" align="center"></el-table-column>
            <el-table-column v-if="!isTransferType" label="Салбар" prop="branch_id" width="150">
              <template #default="scope">
                {{ getBranchName(scope.row.branch_id) }}
              </template>
            </el-table-column>
            <el-table-column v-if="isTransferType" label="Шилжүүлэх салбар" prop="transfer_from_branch_id" width="180">
              <template #default="scope">
                {{ getBranchName(scope.row.transfer_from_branch_id) }}
              </template>
            </el-table-column>
            <el-table-column v-if="isTransferType" label="Хүлээн авах салбар" prop="transfer_to_branch_id" width="180">
              <template #default="scope">
                {{ getBranchName(scope.row.transfer_to_branch_id) }}
              </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column v-if="checkPermissionsPage('admin') && !isDeliveriesRoute" label="Үйлдэл" width="250" align="center">
              <template v-slot="scope">
                <el-button-group>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="createCostDialogOpen(scope.row)"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="edit" class="button-icon-small" />
                    Засварлах
                  </el-button>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="deleteRow(scope.row)"
                    type="danger"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="trash" class="button-icon-small" />
                    Устгах
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
            </template>
          </el-table>

          <!-- Pagination -->
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="data.length"
            layout="total, prev, pager, next, jumper"
            class="modern-pagination" />
    </el-card>
    <CreateCostDialog :selectedCost="this.targetCost" @refresh="loadData" />
  </div>
</template>
<script>
import services from '@/services'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkPermissions } from '@/helpers/custom'
import dayjs from 'dayjs'
import CreateCostDialog from './createCostDialog.vue'

export default {
  name: 'CostListPage',
  components: {
    CreateCostDialog
  },
  created () {
    this.loadCostTypes()
    this.loadBranches()
    this.loadData()
  },
  watch: {
    '$route' (to, from) {
      // Route өөрчлөгдөхөд дахин ачаалах
      this.loadData()
      // Force re-render when route changes
      this.tableKey += 1
    }
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      data: [],
      targetCost: {},
      selectedTypeId: null,
      costTypes: [],
      branches: [],
      tableKey: 0
    }
  },
  computed: {
    pageTitle () {
      if (this.isDeliveriesRoute) {
        return 'Хүргэлт - Зардал'
      }
      if (this.isTransferType) {
        return 'Салбар хооронд шилжүүлэлт - Зардал'
      }
      if (this.selectedTypeId) {
        const costType = this.costTypes.find(ct => ct.id === parseInt(this.selectedTypeId))
        return costType ? `${costType.name} - Зардал` : 'Зардал удирдах хэсэг'
      }
      return 'Зардал удирдах хэсэг'
    },
    pageSubtitle () {
      if (this.selectedTypeId) {
        return 'Сонгосон төрлийн зардлыг үүсгэх, засах, устгах'
      }
      return 'Зардлыг үүсгэх, засах, устгах'
    },
    isRentType () {
      if (this.selectedTypeId) {
        const costType = this.costTypes.find(ct => ct.id === parseInt(this.selectedTypeId))
        return costType && costType.name && costType.name.toLowerCase().includes('түрээс')
      }
      return false
    },
    isDeliveryType () {
      if (this.selectedTypeId) {
        const costType = this.costTypes.find(ct => ct.id === parseInt(this.selectedTypeId))
        return costType && costType.name && costType.name.toLowerCase().includes('хүргэлт')
      }
      return false
    },
    isSalaryType () {
      if (this.selectedTypeId) {
        const costType = this.costTypes.find(ct => ct.id === parseInt(this.selectedTypeId))
        return costType && costType.name && costType.name.toLowerCase().includes('цалин')
      }
      return false
    },
    isFlowCostType () {
      if (this.selectedTypeId) {
        const costType = this.costTypes.find(ct => ct.id === parseInt(this.selectedTypeId))
        return costType && costType.name && (costType.name.toLowerCase().includes('урсгал') || costType.name.toLowerCase().includes('урсгал зардал'))
      }
      return false
    },
    isTransferType () {
      // Route path шалгах
      if (this.$route.path === '/costs/transfer' || this.$route.name === 'costsTransfer') {
        return true
      }
      // CostType-ийн нэрийг шалгах
      if (this.selectedTypeId) {
        const costType = this.costTypes.find(ct => ct.id === parseInt(this.selectedTypeId))
        return costType && costType.name && (costType.name.toLowerCase().includes('шилжүүлэлт') || costType.name.toLowerCase().includes('шилжүүлэх'))
      }
      return false
    },
    isDeliveriesRoute () {
      return this.$route.path === '/costs/deliveries' || this.$route.name === 'costsDeliveries'
    }
  },
  methods: {
    async loadData () {
      try {
        // Хүргэлт route дээр байвал өөр API дуудах
        if (this.isDeliveriesRoute) {
          const response = await services.get('costs/completed-deliveries')
          if (response && response.type === 'success') {
            this.data = response.data || []
            this.totalRecords = response.data?.length || 0
            this.tableKey += 1
          } else if (response && response.data) {
            // Хэрэв response.data шууд массив байвал
            this.data = response.data || []
            this.totalRecords = response.data?.length || 0
            this.tableKey += 1
          } else {
            ElMessage.error('Өгөгдөл олдсонгүй!')
          }
          return
        }

        // Route параметрээс typeId авч байна
        const typeId = this.$route.params.typeId
        this.selectedTypeId = typeId || null

        // "Салбар хооронд шилжүүлэлт" цэс дээр зөвхөн transfer_from_branch_id эсвэл transfer_to_branch_id байгаа зардлуудыг харуулах
        let params = {}
        if (this.$route.path === '/costs/transfer') {
          // Transfer цэс дээр зөвхөн transfer_from_branch_id эсвэл transfer_to_branch_id байгаа зардлуудыг харуулах
          // Backend дээр энэ шүүлтийг хийх хэрэгтэй, одоогоор бүх зардлыг харуулна
        } else if (typeId) {
          params = { type_id: typeId }
        }
        const response = await services.get('costs', params)
        if (response) {
          this.data = response.data || []
          this.totalRecords = response.data?.length || 0
          this.tableKey += 1 // Force table re-render
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    createCostDialogOpen (data) {
      this.targetCost = data || {}
      this.$store.dispatch('setCreateCostDialog', true)
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ зардлыг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })
        await services.delete('costs', row.id)
        this.loadData()
        ElMessage.success('Амжилттай устгагдлаа!')
        const index = this.data.indexOf(row)
        if (index > -1) {
          this.data.splice(index, 1)
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    async changeStatus (data) {
      try {
        const response = await services.update('costs', data)
        if (response && response.data) {
          ElMessage.success('Төлөв амжилттай өөрчлөгдлөө!')
        }
      } catch (error) {
        console.error('Aldaa: ', error.message)
        ElMessage.error(error.message)
      }
    },
    formatAmount (amount) {
      if (!amount) return '0₮'
      return new Intl.NumberFormat('mn-MN', {
        style: 'currency',
        currency: 'MNT',
        minimumFractionDigits: 0
      }).format(amount)
    },
    formatDate (date) {
      if (!date) return '-'
      return dayjs(date).format('YYYY-MM-DD')
    },
    async loadCostTypes () {
      try {
        const response = await services.get('costTypes')
        if (response && response.type === 'success') {
          this.costTypes = response.data || []
        } else if (response && response.data) {
          // Хэрэв response.data шууд массив байвал
          this.costTypes = response.data || []
        }
      } catch (error) {
        console.error('Error loading cost types:', error)
        this.costTypes = []
      }
    },
    async loadBranches () {
      try {
        const response = await services.get('branchesWeb')
        if (response && response.type === 'success') {
          this.branches = response.data || []
        } else if (response && response.data) {
          this.branches = response.data || []
        }
      } catch (error) {
        console.error('Error loading branches:', error)
        this.branches = []
      }
    },
    getBranchName (branchId) {
      if (!branchId) return '-'
      const branch = this.branches.find(b => b.id === branchId)
      return branch ? branch.branch_name : branchId
    },
    async updateDriverPrice (row) {
      try {
        // delivery_id эсвэл id ашиглах (delivery_id нь query-д байгаа)
        const deliveryId = row.delivery_id || row.id
        if (!deliveryId) {
          console.error('Row data:', row)
          ElMessage.warning('Delivery ID олдсонгүй!')
          return
        }
        console.log('Updating driver_price:', { id: deliveryId, driver_price: row.driver_price })
        const response = await services.create('delivery', {
          id: deliveryId,
          driver_price: row.driver_price || 0
        })
        console.log('Update response:', response)
        if (response && response.type === 'success') {
          ElMessage.success('Жолоочид өгөх үнэ амжилттай шинэчлэгдлээ!')
          // Refresh data to show updated value
          this.loadData()
        } else {
          ElMessage.warning('Үнэ шинэчлэхэд алдаа гарлаа')
        }
      } catch (error) {
        console.error('Error updating driver price:', error)
        ElMessage.error(`Үнэ шинэчлэхэд алдаа гарлаа: ${error.message}`)
        // Rollback the value on error
        this.loadData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Cost List Container */
.cost-list-container {
  padding: 0;
}

/* Page Header Card */
.page-header-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title-icon {
  color: #667eea;
  font-size: 32px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.create-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.create-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Table Card */
.table-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-header-icon {
  color: #667eea;
  font-size: 20px;
}

.table-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.table-count-tag {
  border-radius: 20px;
  padding: 4px 12px;
}

/* Modern Cost Table */
.modern-cost-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-cost-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-cost-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 0;
}

.modern-cost-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-cost-table :deep(.el-table__body td) {
  padding: 16px 0;
}

.amount-text {
  font-weight: 600;
  color: #059669;
}

/* Action Buttons */
.action-button {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
}

.button-icon-small {
  margin-right: 4px;
  font-size: 12px;
}

/* Pagination */
.modern-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .action-button {
    margin-bottom: 4px;
    font-size: 11px;
    padding: 6px 8px;
  }

  .button-icon-small {
    display: none;
  }

  /* Mobile Table Scroll */
  .table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-cost-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .create-button {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
